























import PasswordChangeSection from '../../components/organisms/PasswordChangeSection.vue';
import { Session } from '../../utils/Session';
import { Vue, Component } from 'vue-property-decorator';
import { MessageDialog } from '../../utils/MessageDialog';
import { TeacherService } from '../../biz/remote/TeacherService';
import { routeHelper } from '../../utils/routeHelper';
@Component({
  components: {
    PasswordChangeSection,
  },
})
export default class TeacherPasswordChangePage extends Vue {
  currentPage = 0;

  password = '';

  get title() {
    return `パスワードの変更`;
  }

  async register() {
    const result = await MessageDialog.confirm('登録しますよろしいですか？');
    if (!result) {
      return;
    }

    const service = new TeacherService();
    const infoResponse = await service.setNewPassword(Session.getSessionUserId(), this.password);

    if (infoResponse.hasError) {
      MessageDialog.systemError(`登録更新エラー`, `登録時にエラーが発生しました。${infoResponse.errorDescription}`);
    }
    await MessageDialog.alert('パスワードの変更が完了しました。');
    routeHelper(this, 'TeacherDashboardPage');
  }
}
